import FancySeparator from 'app/design/images/fancy-separator';
import { images } from 'app/design/images';
import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { UserLevel } from 'app/schemas/user';
import { Image } from 'expo-image';
import { Trans } from 'react-i18next';
import { View } from 'react-native';

export function FreeSubContributorCelebration({
  userNowContributor,
  width,
}: {
  userNowContributor: boolean;
  width: number;
}) {
  if (!userNowContributor) return null;

  return (
    <Column alignItems="center" gap="spacing.general.x8" paddingHorizontal="spacing.general.x8">
      <Row alignItems="center" style={{ marginHorizontal: 40, marginTop: -10, marginBottom: -10 }}>
        <View style={{ paddingTop: 0 }}>
          <Image source={images.badge.checked[UserLevel.CONTRIBUTOR]} style={{ flex: 1, width: 60, maxHeight: 60 }} />
        </View>
        <Text
          style={{ fontSize: 18, textAlign: 'center', width: width - 2 * 40 - 74, paddingHorizontal: 5 }}
          variant="bodyBase"
        >
          <Trans components={{ strong: <Text fontWeight="700" /> }} i18nKey="userNowContributorText" ns="free-sub" />
        </Text>
      </Row>
      <FancySeparator width={width - 2 * 40} />
    </Column>
  );
}
